import { render, staticRenderFns } from "./MetaData.vue?vue&type=template&id=205d2277&scoped=true"
import script from "./MetaData.vue?vue&type=script&lang=js"
export * from "./MetaData.vue?vue&type=script&lang=js"
import style0 from "./MetaData.vue?vue&type=style&index=0&id=205d2277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d2277",
  null
  
)

export default component.exports